// import cookies from '../utils/cookies';

export const initialCart = {
  isLoading: true,
  isUpdatingCart: false,
  isUpdatingBillingInfo: false,
  userExperience: {
    viewedUpsells: false,
    showUpsellModal: false,
    showNotification: false,
    expandOrderSummary: false,
    showBulkRates: null,
    showFeeDescription: null,
    showUpsellDescription: null,
  },
  validation: {
    errors: {},
    showErrors: false,
    formTouched: false,
  },
  // add feature flags here
  feature: {
    // userInfo: cookies.get('_uic') === 'true',
  },
};

export const cartReducer = (state, action) => {
  // console.log('cartContext', state, action);

  switch (action.type) {
    case 'UPDATE': {
      return {
        ...state,
        ...action.payload,
        isError: false,
      };
    }
    case 'VALIDATION': {
      let validationErrors = state.validation.errors;

      if (action.payload.addErrors) {
        validationErrors = {
          ...state.validation.errors,
          ...action.payload.addErrors,
        };
      }
      if (action.payload.removeErrors) {
        action.payload.removeErrors.forEach((error) => {
          delete validationErrors[error];
        });
      }

      return {
        ...state,
        validation: {
          ...state.validation,
          ...action.payload,
          errors: {
            ...validationErrors,
          },
        },
      };
    }
    case 'EXPERIENCE': {
      return {
        ...state,
        userExperience: {
          ...state.userExperience,
          ...action.payload,
        },
      };
    }
    case 'ERROR': {
      return {
        ...state,
        ...action.payload,
        isError: true,
      };
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
};
